export default function (to, from) {
  const overflowedLayoutWrapper = document.querySelector('#content-wrapper .v-content__wrap')
  if (overflowedLayoutWrapper != null) {
    overflowedLayoutWrapper.scrollTop = 0
  }
}
